export default {
    name: 'gold',
    label: '金色 gold',
    styleDir: 'styles',
    imageDir: 'images',
    cssVars: {
        '--theme-tabbar-shell-bg': 'linear-gradient(135deg, #f8e78c 0%, #8e5811 88%, #b28b1e 100%)',
        '--theme-tabbar-text': 'rgba(62, 31, 5, .76)',
        '--theme-tabbar-active-text': '#ffffff',
        '--theme-tabbar-divider': 'rgba(255, 240, 171, .42)',
        '--theme-tabbar-active-bg': 'linear-gradient(180deg, rgba(126, 74, 8, .72) 0%, rgba(77, 41, 4, .88) 100%)',
        '--theme-tabbar-active-bg-size': '100% 100%',
        '--theme-tabbar-active-bg-position': 'center'
    }
}
